import ColorRenderer, { BaseColorRenderer } from 'app/shared/utilities/color_renderer';
import { Cesium } from 'app/cesium';
import ImsObjectCollection from 'app/shared/collections/ims_object_collection.service';
import { ColorConfigType } from 'app/shared/collections/StatDefinition';
import { isNaN } from 'lodash';

/**
 * Returns the uniqueCesiumColor for a given ims object id and collection
 */
export class ImsObjectUniqueColorRenderer<
    PointValueType = string | number,
> extends BaseColorRenderer {
    _collection: ImsObjectCollection;
    public points: Array<{
        value: PointValueType;
        color: Cesium.Color;
        display?: boolean;
    }>;
    public default: Cesium.Color;
    public readonly type: ColorConfigType;
    public readonly reverse: boolean;
    public readonly defaultName: string;

    constructor(
        collection: ImsObjectCollection,
        points: Array<{ value: PointValueType; color: Cesium.Color }>,
        defaultColor: Cesium.Color,
        defaultName: string,
    ) {
        super();
        this._collection = collection;
        this.points = points;
        this.default = defaultColor || Cesium.Color.WHITE;
        this.type = 'exact';
        this.reverse = false;
        this.defaultName = defaultName;
    }

    getColorByPoints(value: PointValueType | null | undefined): Cesium.Color {
        if (value === null || isNaN(value)) {
            return this.default;
        }
        if (typeof value === 'undefined') {
            return Cesium.Color.WHITE;
        }
        return ColorRenderer._exact(value, this.points, this.default);
    }

    // Returns the uniqueCesiumColor for a given imsObject id
    getColor(value) {
        if (value === null || isNaN(value)) {
            return this.default;
        }
        if (typeof value === 'undefined') {
            return Cesium.Color.WHITE;
        }

        const imsObject = this._collection.all[value];
        if (!imsObject) {
            return this.default;
        }
        return imsObject.uniqueCesiumColor;
    }

    public setPoints(points: Array<{ value: PointValueType; color: Cesium.Color }>) {
        this.points = points;
    }
}
